import { lazy } from "react";

// project import
import Loadable from "../components/Loadable";
import Dashboard from "../layout/Dashboard";
import ProtectedRoute from "./ProtectedRoute";
import NotFound from "../pages/NotFoundPage";
import SessionManager from "../auth/SessionManager";

//render - report page

const Form = Loadable(lazy(() => import("../pages/Forms/UserCreation")));
const CaseUpdateTemplates = Loadable(lazy(() => import("../pages/CaseInfo/CaseUpdateTemplates/CaseUpdateTemplates")));

const UserOrgnization = Loadable(
  lazy(
    () => import("../pages/Settings/UserOrganization/UserOrganizationReport")
  )
);
const Checklist = Loadable(
  lazy(() => import("../pages/Settings/Checklist/ChecklistReport"))
);
const CaseTemplate = Loadable(
  lazy(() => import("../pages/CaseInfo/caseTemplate/index"))
);

const OrganizationCaseDetails = Loadable(
  lazy(() => import("../pages/CaseInfo/caseDetails/OrganizationCaseDetails"))
);
const CaseChecklist = Loadable(
  lazy(() => import("../pages/CaseInfo/caseDetails/CaseChecklist"))
);
const UserResetPassword = Loadable(
  lazy(() => import("../pages/User/UserResetPassword"))
);

const BoardOfArbitrators = Loadable(
  lazy(() => import("../pages/BoardsAndPanels/BoardOfArbitrators/index"))
);

const BoardOfMediators = Loadable(
  lazy(() => import("../pages/BoardsAndPanels/BoardOfMediators/index"))
);

const CaseTask = Loadable(lazy(() => import("../pages/Tasks/CaseTaskTable")));
const CreateTask = Loadable(lazy(() => import("../pages/Tasks/CreateTask")));

//Dashboard


const DashboardDefault = Loadable(
  lazy(() => import("../pages/dashboard/newDashboard/index"))
);

//Application
const ReportGeneration = Loadable(
  lazy(() => import("../pages/Reports/ReportGeneration"))
);
const ReportTemplates = Loadable(
  lazy(() => import("../pages/Settings/ReportTemplates/ReportTemplates"))
);

const GenerationReportTemplates = Loadable(
  lazy(
    () => import("../pages/Settings/ReportTemplates/GenerationReportTemplates")
  )
);

const BulkUpload = Loadable(
  lazy(() => import("../pages/Settings/BulkUpload/BulkUpload"))
);

//Settings
const Users = Loadable(lazy(() => import("../pages/Settings/User/UserReport")));
const UserRoles = Loadable(
  lazy(() => import("../pages/Settings/UserRole/UserRoleReport"))
);
const UserDesignation = Loadable(
  lazy(
    () => import("../pages/Settings/UserDesignations/UserDesignationsReport")
  )
);

const CaseTags = Loadable(
  lazy(() => import("../pages/Settings/CaseTags/caseTagsTable")),
);

const Communication = Loadable(
  lazy(() => import("../pages/Settings/Communication/communication")),
);
const CommunicationForm = Loadable(
  lazy(() => import("../pages/Settings/Communication/communicationForm")),
);

const CommAuditTrailsTable = Loadable(
  lazy(() => import("../pages/Settings/CommAuditTrails/commAuditTrailsTable")),
);


//Repository

const Repository = Loadable(
  lazy(() => import("../pages/Organization/Repository/RepositoryReports"))
);

const RepositoryAward = Loadable(
  lazy(() => import("../pages/Organization/Repository/RepositoryAwardsReports"))
);

//Profile

const ViewProfile = Loadable(
  lazy(() => import("../pages/User/views/UserProfileLite"))
);

//UserRole Route
const UserRoleRouteReport = Loadable(
  lazy(() => import("../pages/UserRoleRoute/UserRoleRoute"))
);

const UserChangePassword = Loadable(
  lazy(() => import("../pages/User/views/UserChangePassword"))
);

const PDFDocuments = Loadable(
  lazy(() => import("../pages/CaseInfo/PDFDocument/PDFDocument"))
);

const Maintanance = Loadable(lazy(() => import("../pages/MaintanancePage")));
const CaseDetailsUpdate = Loadable(
  lazy(() => import("../pages/CaseInfo/caseDetailsUpdate/CaseDetailsUpdate"))
);
const Allotment = Loadable(
  lazy(() => import("../pages/CaseInfo/Allotment//AllotmentCaseDetails"))
);
const CreateAllotment = Loadable(
  lazy(() => import("../pages/CaseInfo/Allotment/Allotment"))
);

const CaseBulkUpdate = Loadable(
  lazy(() => import("../pages/CaseUpdate/CaseBulkUpdate"))
);

const UserRegion = Loadable(
  lazy(() => import("../pages/Settings/UserRegion/UserRegion"))
);

const DocumentSearchPage = Loadable(
  lazy(() => import("../pages/CaseInfo/caseDocuments/DocumentSearchPage")),
);

// Add these imports at the top
const TenantTable = Loadable(
  lazy(() => import("../pages/Masters/TenantTable")),
);


const FileSplitter = Loadable(
  lazy(() => import("../pages/FileSplitter/FileSplitter")),
);

// const OrganizationNoticeGeneration=Loadable(
//   lazy(() => import("../pages/NoticeGeneration/NoticeGeneration"))
// );

// const OrganizationNoticeTemplate= Loadable(
//   lazy(() => import("../pages/NoticeTemplates/organizationNotice"))
// );

// const NoticeTemplate= Loadable(
//   lazy(() => import("../pages/NoticeTemplates/TextEditor/index"))
// );

 const NoticeGeneration = Loadable(
  lazy(() => import("../pages/NoticeGeneration/NoticeGenerater")),
);
const NoticeTemplateTable = Loadable(
  lazy(
    () => import("../pages/Settings/NoticeTemplateBuilder/NoticeTemplateTable"),
  ),
);
const NoticeTemplateForm = Loadable(
  lazy(
    () => import("../pages/Settings/NoticeTemplateBuilder/NoticeTemplateForm"),
  ),
);

const ITSupport = Loadable(
  lazy(() => import("../pages/Tickets/TicketsTable")),
);
const CreateTicket = Loadable(
  lazy(() => import("../pages/Tickets/CreateTicket")),
);

const Pages = Loadable(
  lazy( () => import("../pages/Masters/Pages")),
);

const CaseMapping = Loadable(
  lazy( () => import("../pages/Settings/CaseMapping/CaseMapping")),
);

const ArbitratorAllocation = Loadable(
  lazy(() => import("../pages/ArbitrationAllocation/index")),
);


// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: "/",
  element: (
    //  <ProtectedRoute>
    //   <SessionManager>
    //     <Dashboard />
    //   </SessionManager>
    // </ProtectedRoute>

    <ProtectedRoute>
      <Dashboard />
    </ProtectedRoute>
  ),
  errorElement: <NotFound />,

  children: [
    // {
    //   path: "/home",
    //   element: <Maintanance />,
    // },
    {
      path: "/pages",
      element: <Pages />,
    },
    {
      path: "/masters/tenants",
      // element: <MastersPage />,
      element: <TenantTable />,
    },
    {
      path: "/case/tasks",
      element: <CaseTask />,
    }, 
    {
      path: "/case/tasks/CreateTask",
      element: <CreateTask />,
    },
    {
      path: "/case/tasks/CreateTask/:taskNumber",
      element: <CreateTask />,
    },
    {
      path: "/case/notifications",
      element: <Maintanance />,
    },
    {
      path: "/case/importDocument",
      element: <BulkUpload />,
    },
    {
      path: "/case/reports",
      element: <ReportGeneration />,
    },
    {
      path: "/case/billingandpayments",
      element: <Maintanance />,
    },
    {
      path: "/case/itsupport",
      element: <ITSupport />,
    },
    {
      path: "/case/itsupport/createticket",
      element: <CreateTicket />,
    },
    {
      path: "/case/itsupport/createticket/:ticketId",
      element: <CreateTicket />,
    },
    {
      path: "/",
      element: <DashboardDefault />,
    },
    {
      path: "/home",
      element: <DashboardDefault />,
    },
    {
      path: "/settings/users/",
      element: <Users />,
    },
    {
      path: "/settings/userroles/",
      element: <UserRoles />,
    },
    // User Region
    {
      path: "/settings/useRegion/",
      element: <UserRegion />,
    },
    {
      path: "/settings/userdesignation/",
      element: <UserDesignation />,
    },
    {
      path: "/settings/userrolemapping",
      element: <UserRoleRouteReport />,
    },
    {
      path: "/settings/userorganization",
      element: <UserOrgnization />,
    },
    {
      path: "/settings/caseChecklist",
      element: <Checklist />,
    },
    {
      path: "/settings/caseTags",
      element: <CaseTags />,
    },
    {
      path: "/repositorycentral/masterrepository",
      element: <Repository />,
    },
    {
      path: "/repositorycentral/awardsandorders",
      element: <RepositoryAward />,
    },
    {
      path: "/case/caseallotments/",
      element: <Allotment />,
    },
    {
      path: "/case/caseallotments/createAllotment",
      element: <CreateAllotment />,
    },
    {
      path: "/profile/viewprofile",
      element: <ViewProfile />,
    },
    {
      path: "/profile/changepassword",
      element: <UserChangePassword />,
    },
    {
      path: "/case/users",
      element: <Users />,
    },
    {
      path: "/settings/caseTemplate",
      element: <CaseTemplate />,
    },
    {
      path: "/settings/reportBuilder",
      element: <ReportTemplates />,
    },
    {
      path: "/settings/reportBuilder/create",
      element: <GenerationReportTemplates />,
    },
    {
      path: "/settings/reportBuilder/*",
      element: <GenerationReportTemplates />,
    },
    {
      path: "/case/caseDetails",
      element: <OrganizationCaseDetails />,
    },

    {
      path: "/boardsAndPanel/BoardOfArbitrators",
      element: <BoardOfArbitrators />,
    },
    // /app/Test/Panels
    {
      path: "/boardsAndPanel/BoardOfMediator",
      element: <BoardOfMediators />,
    },
     {
      path: "/case/importFields",
      element: <CaseUpdateTemplates />,
    },
  //    {
  //     path: "/case/noticeGeneration",
  //     element: <OrganizationNoticeGeneration />,
  //   },
	//  {
  //     path: "/case/noticeTemplate",
  //     element: <OrganizationNoticeTemplate />,
  //   },
  //    {
  //     path: "/case/noticeTemplate/create",
  //     element: <NoticeTemplate />,
  //   },
  //     {
  //     path: "/case/noticeTemplate/update/:id",
  //     element: <NoticeTemplate />,
  //   },
      {
      path: "/case/noticeGeneration",
      element: <NoticeGeneration />,
    },
    {
      path: "/settings/noticeTemplateTable",
      element: <NoticeTemplateTable />,
    },
    {
      path: "/settings/noticeTemplate/create",
      element: <NoticeTemplateForm />,
    },
    {
      path: "/settings/noticeTemplate/edit/:Id/",
      element: <NoticeTemplateForm />,
    },
    {
      path: "/case/caseDetails/:id",
      element: <CaseChecklist />,
    },
    {
      path: "/case/caseDetails/update",
      element: <CaseBulkUpdate />,
    },
    {
      path: "/case/caseDetailsUpdate",
      element: <CaseDetailsUpdate />,
    },
    {
      path: "/case/caseDocuments",
      element: <DocumentSearchPage />,
    },
    {
      path: "/settings/pdfdocument",
      element: <PDFDocuments />,
    },
    {
      path: "/case/createMatter",
      element: <Maintanance />,
    },
    {
      path: "/case/createTask",
      element: <CreateTask />,
    },
    {
      path: "/case/addDocument",
      element: <Maintanance />,
    },
    {
      path: "/resetPassword",
      element: <UserResetPassword />,
    },
    {
      path: "/case/fileSplit",
      element: <FileSplitter />,
    },
    {
      path:'/settings/caseMapping',
      element:<CaseMapping />
    },
    {
      path: "/case/arbitratorAllocation",
      element: <ArbitratorAllocation />,
    },
        {
      path: "/settings/communication",
      element: <Communication />,
    },

 {
      path: "/settings/communication/create",
      element: <CommunicationForm />,
    },
    {
      path: "/settings/communication/edit/:Id",
      element: <CommunicationForm />,
    },
       {
      path: "/settings/commAuditTrails",
      element: <CommAuditTrailsTable />,
    },

  ],
};

export default MainRoutes;
